import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-shell__header" }
const _hoisted_2 = {
  id: "duplicate-modal-title",
  class: "modal-shell__title"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  class: "modal-shell__field-label",
  for: "duplicate-title"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "modal-shell__field-name" }, "New survey title")
], -1)
const _hoisted_4 = {
  key: 0,
  class: "duplicate-modal__error"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "modal-shell__field-label",
  for: "duplicate-region"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "modal-shell__field-name" }, "Survey Region")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "duplicate-modal__section-label" }, "What to carry over", -1)
const _hoisted_7 = { id: "duplicate-recipients-label" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "duplicate-modal__note" }, "Response answers are never copied. The copy starts at 0 sent, 0 viewed, 0 done.", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "duplicate-modal__section-label" }, "Sharing", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { id: "duplicate-shareable-label" }, "Allow Sharing", -1)
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  class: "modal-shell__field-label",
  for: "duplicate-visibility"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "modal-shell__field-name" }, "Contact Visibility")
], -1)
const _hoisted_13 = {
  key: 1,
  class: "duplicate-modal__error",
  role: "alert"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "visually-hidden",
  tabindex: "-1",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_15 = { class: "modal-shell__actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_input = _resolveComponent("n-input")!
  const _component_region_select = _resolveComponent("region-select")!
  const _component_n_switch = _resolveComponent("n-switch")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_n_select = _resolveComponent("n-select")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_modal = _resolveComponent("n-modal")!

  return (_openBlock(), _createBlock(_component_n_modal, {
    show: _ctx.showModalRef,
    "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showModalRef) = $event)),
    preset: "card",
    title: "Duplicate Survey",
    "aria-labelledby": "duplicate-modal-title",
    class: "modal-shell duplicate-modal",
    closable: !_ctx.saving,
    "close-on-esc": !_ctx.saving,
    "mask-closable": !_ctx.saving
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, "Copying \"" + _toDisplayString(_ctx.survey?.name) + "\"", 1)
      ])
    ]),
    action: _withCtx(() => [
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_n_button, {
          tertiary: "",
          disabled: _ctx.saving,
          "aria-disabled": _ctx.saving,
          onClick: _ctx.onCancel
        }, {
          default: _withCtx(() => [
            _createTextVNode("Cancel")
          ]),
          _: 1
        }, 8, ["disabled", "aria-disabled", "onClick"]),
        _createVNode(_component_n_button, {
          class: "modal-shell__primary-button",
          type: "primary",
          loading: _ctx.saving,
          disabled: !_ctx.canSubmit,
          "aria-disabled": !_ctx.canSubmit,
          onClick: _ctx.onDuplicate
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Duplicate ")
          ]),
          _: 1
        }, 8, ["loading", "disabled", "aria-disabled", "onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("form", {
        novalidate: "",
        onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDuplicate && _ctx.onDuplicate(...args)), ["prevent"]))
      }, [
        _createVNode(_component_n_space, {
          vertical: "",
          class: "inputs",
          size: 18
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _hoisted_3,
              _createVNode(_component_n_input, {
                id: "duplicate-title",
                value: _ctx.name,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
                placeholder: "Survey title",
                disabled: _ctx.saving,
                status: _ctx.isValidName ? 'default' : 'error'
              }, null, 8, ["value", "disabled", "status"]),
              (!_ctx.isValidName)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Survey title is required"))
                : _createCommentVNode("", true)
            ]),
            _withDirectives(_createElementVNode("div", null, [
              _hoisted_5,
              _createVNode(_component_region_select, {
                "select-id": "duplicate-region",
                modelValue: _ctx.regionId,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.regionId) = $event)),
                disabled: _ctx.saving,
                active: _ctx.showModalRef,
                "onUpdate:loading": _ctx.onRegionsLoading
              }, null, 8, ["modelValue", "disabled", "active", "onUpdate:loading"])
            ], 512), [
              [_vShow, !_ctx.noRegions]
            ]),
            _hoisted_6,
            _createVNode(_component_n_space, {
              justify: "space-between",
              align: "center"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_7, "Copy recipient list (" + _toDisplayString(_ctx.recipientCount) + ")", 1),
                _createVNode(_component_n_switch, {
                  value: _ctx.copyRecipients,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.copyRecipients) = $event)),
                  disabled: _ctx.saving,
                  "aria-labelledby": "duplicate-recipients-label"
                }, null, 8, ["value", "disabled"])
              ]),
              _: 1
            }),
            _hoisted_8,
            _hoisted_9,
            _createVNode(_component_n_space, {
              justify: "space-between",
              align: "center"
            }, {
              default: _withCtx(() => [
                _hoisted_10,
                _createVNode(_component_n_switch, {
                  value: _ctx.shareable,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.shareable) = $event)),
                  disabled: _ctx.saving,
                  "aria-labelledby": "duplicate-shareable-label"
                }, null, 8, ["value", "disabled"])
              ]),
              _: 1
            }),
            (_ctx.shareable)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode(_component_n_select, {
                    id: "duplicate-visibility",
                    value: _ctx.contactVisibility,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.contactVisibility) = $event)),
                    options: _ctx.shareOptions,
                    disabled: _ctx.saving
                  }, null, 8, ["value", "options", "disabled"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.submitError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.submitError), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _hoisted_14
      ], 32)
    ]),
    _: 1
  }, 8, ["show", "closable", "close-on-esc", "mask-closable"]))
}